<template>
    <a-modal
        :class="'modal epic-default'"
        :title="section_type == 'renew' ? $t('covers.modal.title') : $t('claim.view.headers.related_covers')"
        :destroyOnClose="true"
        v-model:open="modal_visible"
        width="auto"
        :dialog-style="{ padding: '0 20px', maxWidth: '1536px' }"
    >
        <template #footer>
            <a-button
                data-cy="back-button"
                :type="section_type == 'claim' ? 'primary' : 'default'"
                key="back"
                @click="handleModalCancel"
            >
                {{ section_type == 'claim' ? $t('claim.view.buttons.close') : $t('covers.modal.buttons.cancel') }}
            </a-button>
        </template>
        <div v-if="section_type == 'renew'" class="flex w-full justify-between items-center">
            <div class="flex w-full lg:w-2/3">
                <form-cia-basic-search :processing="processing" :search_form="search_form" @formSubmit="handleFind" />
            </div>
        </div>
        <div class="form-container overflow-x-auto overflow-visible">
            <covers-table
                :section_type="section_type"
                :search_criteria="covers_search_criteria"
                :claim_id="claim_id"
                @fetchSearchCriteria="handleFetchData"
                @fetchSearchCount="handleFetchCount"
                @handleSelect="handleSelect"
                ref="CoversTable"
            />
        </div>
    </a-modal>
</template>

<script>
import CoversTable from '@/components/tables/Covers.vue';
import FormCiaBasicSearch from '@/components/forms/covers/CiaBasicSearch.vue';

export default {
    components: {
        CoversTable,
        FormCiaBasicSearch,
    },
    computed: {
        isCiaEnabled() {
            return this.$store.state.user.modules.cia;
        },
    },
    data() {
        return {
            search_id: '',
            search_form: {
                basic_search: '',
                cover_id: '',
                cover_type: '',
                reg_no: '',
                years_from: 'all',
                chassis_no: '',
                engine_no: '',
                all_match: 1,
            },
            form_mode: 'results',
            search_values: {},
            covers_search_count: 0,
            covers_search_criteria: {},
            processing: false,
            modal_visible: false,
        };
    },
    props: {
        claim_id: {
            type: String,
            default: '',
        },
        section_type: {
            type: String,
            default: 'claim',
        },
    },
    methods: {
        showModal() {
            this.modal_visible = true;
        },
        handleModalCancel() {
            this.modal_visible = false;
        },
        handleFind() {
            this.search_values = this.search_form;

            if (this.section_type == 'renew') {
                this.search_values.registration_number = this.search_values.basic_search;
                this.search_values.chassis_number = this.search_values.basic_search;
                this.search_values.insurer_policy_number = this.search_values.basic_search;
                this.search_values.broker_policy_number = this.search_values.basic_search;

                this.search_values = {
                    ...this.search_values,
                    all_match: 0,
                };

                this.$refs.CoversTable.fetch({
                    ...this.$refs.CoversTable.params,
                    registration_number: this.search_values.basic_search,
                    chassis_number: this.search_values.basic_search,
                    insurer_policy_number: this.search_values.basic_search,
                    broker_policy_number: this.search_values.basic_search,
                });
            } else {
                let years_from = 0;
                if (this.search_values.years_from !== 'all') {
                    years_from = parseInt(this.search_values.years_from) || 0;
                }

                if (this.search_values.basic_search == '') {
                    this.search_id = '';
                    this.$refs.CoversTable.search_id = '';
                    this.$refs.CoversTable.selected_row_keys = [];
                    this.$refs.CoversTable.fetch({}, this.search_id);
                    return;
                }
                this.search_values.reg_no = this.search_values.basic_search;
                this.search_values.chassis_no = this.search_values.basic_search;
                this.search_values.insurer_policy_number = this.search_values.basic_search;
                this.search_values.broker_policy_number = this.search_values.basic_search;

                this.search_values = {
                    ...this.search_values,
                    basic_search: '',
                    all_match: false,
                };
                years_from = 'all';

                this.processSearchValues({
                    ...this.search_values,
                    years_from: years_from,
                });
            }
        },
        processSearchValues(data) {
            this.processing = true;

            if (this.$store.getters['user/isMultiAssociation']) {
                data.association_id = this.$store.getters['user/currentAssociationId'];
            }
            this.$http
                .post('/api/covers/search', data)
                .then((response) => {
                    this.processing = false;
                    this.search_id = response.data.id;

                    this.$refs.CoversTable.selected_row_keys = [];
                    this.$refs.CoversTable.fetch({}, this.search_id);
                })
                .catch((error) => {
                    if (error.response.status == 403) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.403_mod'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVCM01' }),
                        });
                    }
                })
                .finally(() => {
                    this.processing = false;
                });
        },
        handleFetchData(values) {
            this.covers_search_criteria = values.search_criteria;
            this.processing = false;
        },
        handleFetchCount(values) {
            this.covers_search_count = values.search_count;
        },
        handleSelect(data) {
            this.$emit('select', data);
            this.modal_visible = false;
        },
    },
};
</script>
